
export const AUTHENTICATED = 'AUTHENTICATED';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';
export const UNHELPFULTOKEN = 'UNHELPFULTOKEN';
export const ENTERED = 'ENTERED';
